import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoDDTPassivoStep2Component } from './conservazione-carica-documento-ddt-passivo-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-ddt-passivo-step2', {
            url: '/conservazione-carica-ddt-passivo',
            ncyBreadcrumb: {
                label: 'Carica DDT Passivo',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-ddt-passivo-step2 flex="100"></conservazione-carica-documento-ddt-passivo-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoDDTPassivoStep2Module: string = ng
    .module('conservazione-carica-documento-ddt-passivo-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoDdtPassivoStep2', ConservazioneCaricaDocumentoDDTPassivoStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-ddt-passivo-step2/conservazione-carica-documento-ddt-passivo-step2.module.ts